import { KeyRound, Loader2, Trash2, X } from "lucide-react";

const SecretCodeModal = ({
  open,
  title,
  description,
  code,
  setCode,
  onClose,
  onConfirm,
  loading = false,
  labels = {},
}) => {
  if (!open) return null;

  return (
    <div className="fixed inset-0 z-[120] flex items-center justify-center bg-slate-950/70 p-4 backdrop-blur-sm">
      <button
        type="button"
        aria-label={labels.close || "Fermer"}
        onClick={onClose}
        className="absolute inset-0 cursor-default"
      />

      <form
        onSubmit={(event) => {
          event.preventDefault();
          onConfirm?.();
        }}
        className="relative z-10 w-full max-w-md rounded-3xl border border-rose-100 bg-white p-6 shadow-2xl sm:p-7"
      >
        <button
          type="button"
          onClick={onClose}
          disabled={loading}
          className="absolute right-4 top-4 inline-flex h-9 w-9 items-center justify-center rounded-xl text-slate-400 transition hover:bg-slate-100 hover:text-slate-700 disabled:opacity-50"
        >
          <X className="h-4 w-4" />
        </button>

        <div className="flex items-start gap-4 pr-8">
          <span className="flex h-12 w-12 shrink-0 items-center justify-center rounded-2xl bg-rose-50 text-rose-600 ring-1 ring-rose-100">
            <KeyRound className="h-6 w-6" />
          </span>
          <div>
            <p className="text-xs font-black uppercase tracking-[0.18em] text-rose-600">
              {labels.protectedDeletion || "Suppression protégée"}
            </p>
            <h2 className="mt-2 text-xl font-black text-slate-950">{title}</h2>
          </div>
        </div>

        <div className="mt-5 rounded-2xl border border-rose-100 bg-rose-50 px-4 py-3 text-sm leading-6 text-rose-800">
          {description}
        </div>

        <label className="mt-5 block">
          <span className="text-sm font-bold text-slate-700">
            {labels.codeLabel || "Code de suppression"}
          </span>
          <input
            autoFocus
            type="password"
            autoComplete="off"
            value={code}
            onChange={(event) => setCode(event.target.value)}
            placeholder={labels.codePlaceholder || "Saisissez le code de suppression"}
            className="mt-2 h-12 w-full rounded-xl border border-slate-200 px-4 text-sm outline-none transition focus:border-rose-400 focus:ring-4 focus:ring-rose-100/70"
          />
        </label>

        <div className="mt-6 flex flex-col-reverse gap-3 sm:flex-row sm:justify-end">
          <button
            type="button"
            onClick={onClose}
            disabled={loading}
            className="h-11 rounded-xl border border-slate-200 px-5 text-sm font-bold text-slate-700 transition hover:bg-slate-50 disabled:opacity-50"
          >
            {labels.cancel || "Annuler"}
          </button>
          <button
            type="submit"
            disabled={loading || !String(code || "").trim()}
            className="inline-flex h-11 items-center justify-center gap-2 rounded-xl bg-rose-600 px-5 text-sm font-bold text-white transition hover:bg-rose-700 disabled:cursor-not-allowed disabled:opacity-50"
          >
            {loading ? (
              <Loader2 className="h-4 w-4 animate-spin" />
            ) : (
              <Trash2 className="h-4 w-4" />
            )}
            {loading
              ? labels.deleting || "Suppression…"
              : labels.confirm || "Confirmer la suppression"}
          </button>
        </div>
      </form>
    </div>
  );
};

export default SecretCodeModal;
